import { render, staticRenderFns } from "./FiltersBox.vue?vue&type=template&id=4c101890&scoped=true&"
import script from "./FiltersBox.vue?vue&type=script&lang=js&"
export * from "./FiltersBox.vue?vue&type=script&lang=js&"
import style0 from "./FiltersBox.vue?vue&type=style&index=0&id=4c101890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c101890",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectComponent: require('/home/bitrix/frontend/components/form/SelectComponent.vue').default,Genres: require('/home/bitrix/frontend/components/gallery/Genres.vue').default,MtSwitch: require('/home/bitrix/frontend/components/form/MtSwitch.vue').default})
